import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { OrganizationService } from '../organization.service';
import { Organization } from '../organization.model';

@Component({
  selector: 'app-organization-detail',
  templateUrl: './organization-detail.component.html',
  styleUrls: ['./organization-detail.component.scss']
})
export class OrganizationDetailComponent implements OnInit {

  public organizationId: number;
  public organization: Organization;


  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public organizationService: OrganizationService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      if (params.org_id) {
        this.organizationId = params.org_id;
        this.organization = this.organizationService.organization(this.organizationId);
        if (!this.organization) {
          this.router.navigate(['../organizations']);
        } else {
          this.organizationService.getOrgUsers(this.organization.id);
        }
      } else {
        this.router.navigate(['../organizations']);
      }
    })
  }

}
